export default __webpack_public_path__ + "static/media/revealed1.90f5402f.png";